import { render, staticRenderFns } from "./CommunityPosts.vue?vue&type=template&id=2cc6e786&scoped=true&"
import script from "./CommunityPosts.vue?vue&type=script&lang=js&"
export * from "./CommunityPosts.vue?vue&type=script&lang=js&"
import style0 from "./CommunityPosts.vue?vue&type=style&index=0&id=2cc6e786&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc6e786",
  null
  
)

export default component.exports